import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();
  errors.entity = [];

  if (!record.name || !record.name.trim().length) {
    errors.messages.push(i18n("isValid.Name"));
    errors.entity.push("name");
  }

  if (!record.sortOrder) {
    errors.messages.push(i18n("isValid.SortOrder"));
    errors.entity.push("sortOrder");
  }

  return errors;
}
